import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { parseLanguagePath } from './i18n/routing';

const container = document.getElementById('root');
const { language, basename } = parseLanguagePath(window.location.pathname);
const app = (
  <Router basename={basename ? `${basename}/` : "/"}>
    <App language={language} />
  </Router>
);

if (container.dataset.prerendered) {
  // Let the prerendered content paint before attaching React behavior.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => ReactDOM.hydrateRoot(container, app));
  });
} else {
  ReactDOM.createRoot(container).render(app);
}
